var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56954 16V8.71108H8.10584L8.48661 5.85739H5.56954V4.04141C5.56954 3.21625 5.8051 2.65677 7.02485 2.65677H8.57051V0.112522C8.30268 0.0781405 7.3798 0 6.30526 0C4.0626 0 2.52662 1.32526 2.52662 3.76011V5.86052H0V8.7142H2.52662V16H5.56954Z",
    fill: "#27272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c066d1edf6d283d3f961f191de620283.svg";
export { ForwardRef as ReactComponent };